var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g, _path42, _g2, _path43, _g3, _path44, _g4, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g5, _path55, _g6, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeginBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 840,
    height: 254,
    viewBox: "0 0 840 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1944_6953)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.527 131.158H287.773L288.322 214.873",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.405 131.158H295.037V117.762L239.928 117.892L143.305 118.136L197.292 117.999L294.991 117.754",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.747 215.011L197.297 118.006",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.539 214.309H288.323",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.799 118.128L104.727 117.678V214.309H184.353",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.367 168.53H252.955V214.324H229.367V168.53Z",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.66 131.158H158.689V156.652H132.66V131.158Z",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M234.387 97.3633L247.439 116.572",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M224.922 97.3633L237.974 116.572",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M186.746 96.0359H240.009L254.449 116.572H201.187L186.746 96.0359Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M215.453 97.3633L228.506 116.572",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.984 97.3633L219.037 116.572",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.52 97.3633L209.572 116.572",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M192.757 118.044H195.145V103.718H192.757V118.044Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M246.258 106.968H196.52",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.836 96.0359H178.098L192.539 116.572H139.277L124.836 96.0359Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.843 118.044H133.23V103.718H130.843V118.044Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M172.465 97.3633L185.525 116.572",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M163.008 97.3633L176.06 116.572",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M153.539 97.3633L166.592 116.572",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.074 97.3633L157.127 116.572",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M134.605 97.3633L147.658 116.572",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M184.344 106.968H134.605",
    stroke: "black",
    strokeWidth: 0.762855,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M625.77 55.3528H732.348",
    stroke: "black",
    strokeWidth: 0.381428,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M617.297 64.4307H722.739",
    stroke: "black",
    strokeWidth: 0.381428,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M608.812 73.5088H715.772",
    stroke: "black",
    strokeWidth: 0.381428,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M599.863 82.5867H706.327",
    stroke: "black",
    strokeWidth: 0.381428,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M590.887 91.6571H699.159",
    stroke: "black",
    strokeWidth: 0.381428,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M583.379 100.735H691.895",
    stroke: "black",
    strokeWidth: 0.381428,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M671.977 131.333H566.84V116.602L627.418 51.7521L733.638 52.0191L674.288 116.862L566.878 116.595",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M673.793 223.517L674.289 116.877",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M639.027 171.65H613.09V221.998H639.027V171.65Z",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M566.84 222.738H704.917V162.351H767.15L767.135 222.738H776.068V116.511L735.362 51.8284",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M674.037 131.333H574.82L574.469 221.999",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M643.812 51.7445V40.0957H661.145V51.7445",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M665.166 33.7106H639.793V40.0957H665.166V33.7106Z",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M658.536 58.8237L631.127 89.1549L601.719 89.2617L630.982 58.9229L658.536 58.8237Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M616.791 89.2084L615.754 89.216L643.644 58.8773L644.59 58.8696L616.791 89.2084Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M689.935 58.8237L662.518 89.1549L633.117 89.2617L660.382 58.9229L689.935 58.8237Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M721.548 58.8237L694.131 89.1549L664.73 89.2617L691.995 58.9229L721.548 58.8237Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M647.29 89.216H646.512L674.379 58.8773L675.355 58.8696L647.29 89.216Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M679.046 89.216H678.207L706.089 58.8773L707.058 58.8696L679.046 89.216Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1944_6953",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 601,
    y: 58,
    width: 58,
    height: 32
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M658.536 58.8237L631.127 89.1549L601.719 89.2617L630.982 58.9229L658.536 58.8237Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1944_6953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656.967 62.3481H624.637V63.111H656.967V62.3481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.838 67.6805H619.508V68.4434H651.838V67.6805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.713 73.0128H614.383V73.7757H646.713V73.0128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.588 78.3452H609.258V79.1081H641.588V78.3452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.467 83.6852H604.137V84.448H636.467V83.6852Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1944_6953",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 633,
    y: 58,
    width: 57,
    height: 32
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M689.935 58.8237L662.518 89.1549L633.117 89.2617L660.382 58.9229L689.935 58.8237Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1944_6953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656.964 62.3481L656.43 63.111H689.301V62.3481H656.964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.174 67.6805H651.844V68.4434H684.174V67.6805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.049 73.0128H646.719V73.7757H679.049V73.0128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.92 78.3452H641.59V79.1081H673.92V78.3452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.795 83.6852H636.465V84.448H668.795V83.6852Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1944_6953",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 664,
    y: 58,
    width: 58,
    height: 32
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M721.548 58.8237L694.131 89.1549L664.73 89.2617L691.995 58.9229L721.548 58.8237Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1944_6953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.838 62.3481H688.508V63.111H720.838V62.3481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.713 67.6805H683.383V68.4434H715.713V67.6805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.595 73.0128H678.266V73.7757H710.595V73.0128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.467 78.3452H673.137V79.1081H705.467V78.3452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.342 83.6852H668.012V84.448H700.342V83.6852Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1944_6953",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 704,
    y: 162,
    width: 65,
    height: 70
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M768.431 162.351H704.152V231.29H768.431V162.351Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1944_6953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M749.073 190.462C749.073 190.462 740.392 171.498 734.289 171.498C728.186 171.498 696.688 171.498 696.688 171.498C696.688 171.498 692.828 174.389 687.686 180.339C682.544 186.282 675.793 197.213 675.793 197.213V211.357L678.043 213.287",
    stroke: "black",
    strokeWidth: 2.15888,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.362 213.279H693.469",
    stroke: "black",
    strokeWidth: 2.15888,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.41 171.498C699.41 171.498 714.034 183.07 714.995 190.462C714.995 190.462 746.173 190.462 752.917 190.462C759.668 190.462 762.239 198.815 762.239 198.815V213.279H720.778",
    stroke: "black",
    strokeWidth: 2.15888,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.395 190.462H715.002",
    stroke: "black",
    strokeWidth: 2.15888,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.997 213.279C759.997 213.279 757.587 221.632 751.156 221.632C743.733 221.632 741.91 213.745 741.91 213.745",
    stroke: "black",
    strokeWidth: 2.15888,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.072 224.074C717.331 224.074 720.784 219.312 720.784 213.439C720.784 207.566 717.331 202.805 713.072 202.805C708.812 202.805 705.359 207.566 705.359 213.439C705.359 219.312 708.812 224.074 713.072 224.074Z",
    stroke: "black",
    strokeWidth: 2.15888,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.873 213.439C726.873 219.313 723.418 224.074 719.161 224.074H713.363",
    stroke: "black",
    strokeWidth: 2.15888,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.785 194.322C720.785 194.322 730.832 196.252 730.832 206.215",
    stroke: "black",
    strokeWidth: 2.15888,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.534 204.239H740.07",
    stroke: "black",
    strokeWidth: 2.15888,
    strokeLinejoin: "round"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M694.571 169.293H692.656C690.238 169.293 688.277 171.253 688.277 173.672V185.381C688.277 187.8 690.238 189.76 692.656 189.76H694.571C696.989 189.76 698.95 187.8 698.95 185.381V173.672C698.95 171.253 696.989 169.293 694.571 169.293Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M693.628 188.967H687.311C685.229 188.967 683.535 187.281 683.535 185.191V173.901C683.535 171.818 685.221 170.124 687.311 170.124H693.628",
    stroke: "black",
    strokeWidth: 1.52571,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M695.167 173.573L691.223 179.744H693.198L692.268 185.473L697.325 178.325H694.861L695.167 173.573Z",
    fill: "#CEFF00"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M692.726 188.967H689.965V193.658H692.726V188.967Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M691.342 193.651C691.342 198.892 691.19 205.284 692.372 210.754C693.555 216.224 697.346 218.878 700.26 216.079C703.174 213.279 702.205 194.864 705.722 195.764C709.506 196.725 710.475 196.725 710.475 196.725",
    stroke: "black",
    strokeWidth: 1.52571,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M712.753 194.452H708.199V199.006H712.753V194.452Z",
    stroke: "black",
    strokeWidth: 1.52571,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M574.468 214.309H244.266",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M776.059 214.278H840.001",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M104.724 214.309L21.3516 214.271",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1944_6953",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 47,
    width: 128,
    height: 207
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M126.656 117.228H104.716V223.784C104.716 223.784 83.0664 258.966 76.2998 252.2C69.5409 245.433 -0.527326 136.856 -0.00095572 134.629C0.525414 132.401 22.7855 70.6709 22.7855 70.6709L70.9751 47.0834L117.83 54.239L126.656 117.228Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1944_6953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6007 223.784L81.4883 158.361",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5335 158.697L66.8867 139.824",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3438 158.262L88.2247 135.384",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2218 143.051C77.3993 139.931 74.5767 135.59 75.4921 130.929C76.2474 127.015 80.1761 124.628 84.0285 125.398C86.3628 125.726 88.9794 127.305 90.589 128.549C92.4962 130.059 91.9774 129.052 91.657 127.763C90.5662 123.514 85.989 110.362 91.0696 105.671C92.4123 104.671 93.9685 104.961 95.2959 106.067C97.3098 107.7 98.6219 111.209 99.3466 113.574C99.9416 115.26 100.14 117.022 101.055 116.412C103.512 113.902 105.953 110.103 110.133 107.99C112.765 106.563 116.671 106.197 118.365 109.081C119.555 111.163 119.684 113.238 119.806 116.045C119.89 122.782 118.403 130.189 116.419 136.719C114.283 144.004 111.537 148.429 106.632 153.761C100.697 160.619 94.9526 161.527 86.2026 159.948",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5002 111.583C99.5002 111.583 114.628 98.0803 99.1417 96.0969C83.6558 94.1135 73.9294 124.185 73.9294 124.185C73.9294 124.185 68.7038 98.0727 61.327 101.498C53.9425 104.916 59.1681 135.353 59.1681 135.353C59.1681 135.353 47.9999 124.727 41.1647 134.636C34.3143 144.538 50.708 167.592 77.1715 165.25",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9102 100.43C86.9102 100.43 92.8986 72.6009 110.162 76.8271C127.418 81.061 110.124 107.997 110.124 107.997",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0391 105.366C83.0391 105.366 86.388 61.5091 70.719 64.5071C55.0347 67.5051 59.0931 104.313 59.0931 104.313",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1557 134.629C41.1557 134.629 31.2615 108.356 57.3206 111.697",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.116 76.4763C103.116 76.4763 97.6537 53.7584 80.2148 71.8991",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6007 223.784L81.4883 158.361",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5335 158.697L66.8867 139.824",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3438 158.262L88.2247 135.384",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2218 143.051C77.3993 139.931 74.5767 135.59 75.4921 130.929C76.2474 127.015 80.1761 124.628 84.0285 125.398C86.3628 125.726 88.9794 127.305 90.589 128.549C92.4962 130.059 91.9774 129.052 91.657 127.763C90.5662 123.514 85.989 110.362 91.0696 105.671C92.4123 104.671 93.9685 104.961 95.2959 106.067C97.3098 107.7 98.6219 111.209 99.3466 113.574C99.9416 115.26 100.14 117.022 101.055 116.412C103.512 113.902 105.953 110.103 110.133 107.99C112.765 106.563 116.671 106.197 118.365 109.081C119.555 111.163 119.684 113.238 119.806 116.045C119.89 122.782 118.403 130.189 116.419 136.719C114.283 144.004 111.537 148.429 106.632 153.761C100.697 160.619 94.9526 161.527 86.2026 159.948",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5002 111.583C99.5002 111.583 114.628 98.0803 99.1417 96.0969C83.6558 94.1135 73.9294 124.185 73.9294 124.185C73.9294 124.185 68.7038 98.0727 61.327 101.498C53.9425 104.916 59.1681 135.353 59.1681 135.353C59.1681 135.353 47.9999 124.727 41.1647 134.636C34.3143 144.538 50.708 167.592 77.1715 165.25",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9102 100.43C86.9102 100.43 92.8986 72.6009 110.162 76.8271C127.418 81.061 110.124 107.997 110.124 107.997",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0391 105.366C83.0391 105.366 86.388 61.5091 70.719 64.5071C55.0347 67.5051 59.0931 104.313 59.0931 104.313",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1557 134.629C41.1557 134.629 31.2615 108.356 57.3206 111.697",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.116 76.4763C103.116 76.4763 97.6537 53.7584 80.2148 71.8991",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1944_6953",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 288,
    y: 143,
    width: 107,
    height: 72
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M394.544 143.905H288.316V214.278H394.544V143.905Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1944_6953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.352 184.184C282.443 156.82 300.667 164.273 308.273 171.414C314.284 177.364 316.733 186.099 316.733 186.099C316.733 186.099 321.608 180.072 328.329 178.203C333.592 176.204 346.134 174.145 354.182 181.918C357.424 184.344 364.106 191.492 364.938 200.654",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 190.63C309.59 184.024 297.903 192.384 297.903 192.384C297.903 192.384 292.319 181.72 281.418 181.148C280.731 181.109 280.075 181.14 279.419 181.224C275.971 181.43 268.121 183.963 264.376 192.384C255.435 190.973 240.01 193.43 249.851 214.515",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.993 214.278C294.993 214.278 285.038 208.115 293.132 198.297C301.233 188.479 313.836 198.525 313.836 198.525C313.836 198.525 319.016 187.571 328.971 185.282C336.798 183.467 352.513 185.519 352.795 208.282C359.966 200.944 375.627 191.873 380.898 214.278",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M186.176 181.27H161.559V217.002H186.176V181.27Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M175.342 192.781L171.398 198.945H173.374L172.444 204.682L177.501 197.526H175.037L175.342 192.781Z",
    fill: "#CEFF00"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M186.176 182.917H192.538V215.446H186.176",
    stroke: "black",
    strokeWidth: 3.05142,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M163.61 208.649H154.715",
    stroke: "black",
    strokeWidth: 1.52571,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M156.996 206.375H152.441V210.929H156.996V206.375Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M678.469 11.2597C671.436 0.419519 664.601 2.35717 660.642 3.0056L655.172 23.4501C661.374 20.5818 666.02 19.5901 676.997 25.3496C685.663 29.8962 693.322 24.3274 696.343 20.7496C691.14 21.1082 683.359 18.8043 678.469 11.2597Z",
    fill: "#FF4D1E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M654.691 24.0147L660.39 2.72345L660.588 2.69294C660.817 2.6548 661.053 2.61665 661.297 2.57088C665.295 1.86906 671.993 0.694258 678.729 11.092C683.573 18.5527 691.224 20.7955 696.312 20.437L697.052 20.3836L696.572 20.9557C693.307 24.8234 685.48 30.1634 676.837 25.632C665.661 19.7656 661.046 21.0701 655.286 23.7401L654.676 24.0224L654.691 24.0147ZM660.893 3.28034L655.652 22.8857C661.305 20.3378 666.111 19.2774 677.15 25.0751C685.037 29.2098 692.231 24.7547 695.618 21.1006C690.377 21.2074 682.97 18.7739 678.21 11.4353C671.695 1.39609 665.508 2.47934 661.412 3.19642C661.236 3.22694 661.061 3.25745 660.893 3.28797V3.28034Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.465 17.5534C672.381 18.034 672 18.3772 671.557 18.4535L671.496 18.423C670.604 18.0492 669.299 17.5 667.224 17.1567C665.798 16.9202 664.448 16.9507 663.494 17.0575L663.334 17.0422C662.685 16.9812 662.235 16.3862 662.35 15.7454L663.357 10.0926C663.418 9.74934 663.639 9.45183 663.952 9.29926L668.453 7.04883C668.887 6.82761 669.422 6.92678 669.757 7.27769L673.205 10.9394C673.442 11.1911 673.549 11.5497 673.487 11.893L672.481 17.5457L672.465 17.5534ZM667.469 16.0276C667.484 14.5324 666.576 13.1898 665.203 12.694C665.15 12.6787 665.165 12.5948 665.218 12.5948C666.675 12.5948 667.995 11.6565 668.491 10.2452C668.514 10.1918 668.59 10.1994 668.59 10.2605C668.575 11.7557 669.483 13.0983 670.856 13.5941C670.909 13.617 670.894 13.6933 670.84 13.6933C669.383 13.6933 668.064 14.6316 667.568 16.0429C667.545 16.0963 667.469 16.0887 667.469 16.0276Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M653.675 32.9478L661.716 1.64782V1.60205L661.723 1.55627C661.693 0.671362 661.479 0.167878 661.06 0.0305636C660.518 -0.152522 660.007 0.381477 659.809 0.617962L659.763 0.671362L651.547 32.9401H653.675V32.9478Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M122.491 74.5158C129.524 63.6756 136.36 65.6133 140.319 66.2617L145.788 86.7062C139.586 83.8379 134.941 82.8462 123.963 88.6057C115.297 93.1524 107.638 87.5835 104.617 84.0057C109.82 84.3643 117.601 82.0604 122.491 74.5158Z",
    fill: "#FF4D1E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M145.661 86.9884C139.901 84.326 135.286 83.0139 124.11 88.8803C115.467 93.4116 107.64 88.0717 104.375 84.204L103.895 83.6318L104.635 83.6852C109.723 84.0361 117.382 81.801 122.218 74.3403C128.954 63.9502 135.652 65.125 139.65 65.8192C139.894 65.8649 140.13 65.9031 140.359 65.9412L140.557 65.9717L146.256 87.263L145.646 86.9808L145.661 86.9884ZM139.558 66.4447C135.461 65.7276 129.275 64.6444 122.76 74.6835C118 82.0222 110.592 84.4557 105.352 84.3489C108.739 88.003 115.94 92.4581 123.82 88.3234C134.859 82.5333 139.657 83.5861 145.318 86.134L140.077 66.5286C139.909 66.4981 139.733 66.4676 139.558 66.4371V66.4447Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.49 75.1489C127.429 74.8056 127.535 74.4547 127.772 74.1953L131.22 70.5336C131.556 70.1751 132.082 70.0835 132.524 70.3048L137.025 72.5552C137.338 72.7154 137.559 73.0053 137.62 73.3486L138.627 79.0013C138.742 79.6421 138.284 80.2371 137.643 80.2982L137.483 80.3134C136.529 80.199 135.179 80.1761 133.753 80.4126C131.678 80.7559 130.381 81.2975 129.481 81.6789L129.42 81.7095C128.969 81.6332 128.596 81.2899 128.512 80.8093L127.505 75.1565L127.49 75.1489ZM133.394 79.2988C132.898 77.8875 131.578 76.9416 130.121 76.9492C130.06 76.9492 130.053 76.8729 130.106 76.8501C131.479 76.3542 132.387 75.0116 132.372 73.5164C132.372 73.4554 132.448 73.4401 132.471 73.5011C132.967 74.9124 134.287 75.8584 135.744 75.8507C135.805 75.8507 135.812 75.927 135.759 75.9499C134.386 76.4458 133.478 77.7884 133.493 79.2836C133.493 79.3446 133.417 79.3599 133.394 79.2988Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M147.283 96.2036L139.242 64.9037V64.8579L139.234 64.8121C139.265 63.9272 139.478 63.4237 139.898 63.2864C140.44 63.1033 140.951 63.6373 141.149 63.8738L141.195 63.9272L149.411 96.196H147.283V96.2036Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1944_6953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 840.003,
    height: 253.062,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginBottom);
export default __webpack_public_path__ + "static/media/begin_bottom.e038b44a3026dc17c32cfbc7eb59f363.svg";
export { ForwardRef as ReactComponent };